export default __webpack_public_path__ + "static/open-sans-latin-600-normal-b921b5774885cba269a52f56c071c27d.woff2";